import React, { FC, memo, useCallback } from 'react'

import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { useTranslation } from '../../../hooks/locale'
import { Slide } from 'pure-react-carousel'
import { Container, SliderContainer } from './styles'
import { CtaButtonText, CtaContainer, StyledGhostButton, Subtitle, Title, TitleContainer } from '../common/styles'
import GridCard from '../../common/grid-card'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { Offer } from '../../../models/common/offers-model'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { useResponsiveCards } from '../../../hooks/responsive'
import { StyledCarouselProvider, StyledSlider } from '../../common/listing-card-section/styles'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'

interface PopularFilterListingsProps {
    popularFilterListingsSection: ListingSectionTransport
    url: string
    sectionId: string
    sitePathname?: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const PopularFilterListingsSection: FC<PopularFilterListingsProps> = ({
    popularFilterListingsSection,
    url,
    sectionId,
    sitePathname,
    breadcrumbModel,
    offerModel,
    suitablesModel,
}) => {
    const { t } = useTranslation()

    const _handleViewAllAccommodationsClick = useCallback(() => {
        document.location.href = popularFilterListingsSection?.cta?.url || url
    }, [popularFilterListingsSection?.cta?.url, url])

    const popularFilterListingObjects = popularFilterListingsSection?.objects

    const visibleSlides = useResponsiveCards()
    const dragStep = Math.floor(visibleSlides)

    if (popularFilterListingsSection?.objects?.length <= 0) {
        return null
    }

    return (
        <Container id={sectionId}>
            <TitleContainer>
                <Title>{popularFilterListingsSection.heading}</Title>
                <Subtitle>{popularFilterListingsSection.subheading}</Subtitle>
            </TitleContainer>

            <SliderContainer>
                <StyledCarouselProvider
                    totalSlides={popularFilterListingObjects.length}
                    visibleSlides={visibleSlides}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={dragStep}
                    step={dragStep}
                >
                    <StyledSlider $transitionTime={0.2}>
                        {popularFilterListingObjects.map((object, index) => (
                            <Slide index={object.id} key={`${index}_${object.id}`}>
                                <GridCard
                                    index={index}
                                    listingObject={object}
                                    requestUrl={url}
                                    sitePathname={sitePathname}
                                    pageName={pageTypeEventCategories.REGION_LANDING_PAGE}
                                    sectionName={cardEventCategories.sections.POPULAR_FILTER_LISTINGS}
                                    breadcrumbModel={breadcrumbModel}
                                    offerModel={offerModel}
                                    suitablesModel={suitablesModel}
                                    showFeatures={false}
                                />
                            </Slide>
                        ))}
                    </StyledSlider>
                </StyledCarouselProvider>
            </SliderContainer>

            {popularFilterListingsSection.cta?.url && (
                <CtaContainer>
                    <StyledGhostButton onClick={_handleViewAllAccommodationsClick} borderRadius="16px">
                        <CtaButtonText>{t('seeAll')}</CtaButtonText>
                    </StyledGhostButton>
                </CtaContainer>
            )}
        </Container>
    )
}

export default memo(PopularFilterListingsSection)
